import { SET_SERVICE_PRICES, API_SERVICES_FETCH_ALL_START, API_SERVICES_FETCH_ALL_SUCCESS, API_SERVICES_FETCH_ALL_FAILURE } from '../types/services'

export const setServicePrices = apiServices => ({ type: SET_SERVICE_PRICES, apiServices })
export const apiServicesFetchAllStart = () => ({ type: API_SERVICES_FETCH_ALL_START })
export const apiServicesFetchAllSuccess = () => ({ type: API_SERVICES_FETCH_ALL_SUCCESS })
export const apiServicesFetchAllFailure = error => ({ type: API_SERVICES_FETCH_ALL_FAILURE, error })
